export default {
	create: 'Создать',
	back: 'Назад',
	save: 'Сохранить',
	delete: 'Удалить',
	settings: 'Настройки',
	open: 'Открыть',
	apply: 'Применить',
	edit: 'Редактировать',
	reject: 'Отклонить',
	close: 'Закрыть',
	notifyLeave: 'Уведомить о дате выезда',
	notifyExtend: 'Уведомить о продлении договор'
};
